import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './Offers.css';

const SERVER_URL = process.env.REACT_APP_TEST_API_URL;
const Offers = () => {

// State for offers and form
const [offers, setOffers] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const navigate = useNavigate();

  // Load initial data (simulated)
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try{
      const response = await fetch(`${SERVER_URL}/api/offer/getAll`);
      const offers = await response.json();
      setOffers(offers);
    }   
    catch(error) {
      console.error('There was a problem with the fetch operation:', error);
    };
  };

  // Delete offer
  const deleteOffer = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to delete this offer?')) {
      await fetch(`${SERVER_URL}/api/offer/delete/${id}`);
      setOffers(offers.filter(offer => offer._id !== id));
      fetchData()
    }
  };

  // Navigate to update Offer page
  const updateOffer = async(id) => {
    console.log(id)
    navigate(`/editOffer/${id}`); 
  };

  // Navigate to create offer page
  const handleCreateOffer = () => {
    navigate('/createOffer'); 
  };

  // Filter offers based on search term
  const filteredOffers = offers.filter(offer => 
    offer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    offer.description.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
 
    <div className="user-management">   
      
      <div className="header-container">
        {/* <h3>Offers List</h3> */}
        <button 
          className="create-offer-btn"
          onClick={handleCreateOffer}
        >
          Create Offer
        </button>
      </div>
      
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search offers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
              
      <div className="users-table-container">
        <h3>Offers List</h3>
        {offers.length > 0 ? (
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Description</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOffers.map((offer,index) => (
                <tr key={offer._id}>
                  <td>{index+1}</td>
                  <td>{offer.name}</td>
                  <td>{offer.description}</td>
                  <td>
                    {offer.imageUrl ? (
                    <img 
                    src={SERVER_URL+'/'+offer.imageUrl} 
                    alt="Preview" 
                    style={{ 
                      maxWidth: '100px', 
                      maxHeight: '100px', 
                      marginLeft: '10px' 
                    }} 
                  />
                    ) : (
                    <span>No image Provided</span>
                    )}
                  </td>                
                  <td className="">
                    <button
                      className="btn-edit"
                      onClick={() => updateOffer(offer._id)}
                    >
                      Edit
                    </button>
                    <br/>
                    <br/>
                    <button
                      className="btn-delete"
                      onClick={() => deleteOffer(offer._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-users">No offers found.</p>
        )}
      </div>
    </div>
        
  );
};

export default Offers;